module.exports = __webpack_public_path__ + "static/finance-b083a415f47977e1a73c7cf2560b0b55.png";